import axios  from '@/request/request'

// 通用获取数据功能
export function commonGet(url) {
    return axios({
        url,
        method: 'get',
    })
}
